import { __assign, __rest } from "tslib";
import React from 'react';
import { withI18nextProvider } from './withI18nextProvider';
export function withSharedComponentProviders(Comp) {
    return withCustomtLink(withI18nextProvider(Comp));
}
function withCustomtLink(Comp) {
    return function (props) {
        var linkComponentFn = props.linkComponentFn, outsideProps = __rest(props, ["linkComponentFn"]);
        var customLink = linkComponentFn;
        if (!customLink) {
            customLink = function (props) { return (React.createElement("a", { className: props.className, target: props.target, href: props.href || props.to, onClick: props.onClick, "data-hook": props.dataHook }, props.children)); };
        }
        return (React.createElement(Comp, __assign({}, __assign(__assign({}, outsideProps), { linkComponentFn: customLink }))));
    };
}
//# sourceMappingURL=index.js.map